import { render, staticRenderFns } from "./UpdateProxySetting.vue?vue&type=template&id=513186b0&"
import script from "./UpdateProxySetting.vue?vue&type=script&lang=js&"
export * from "./UpdateProxySetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports